import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ItemComponentBase } from 'products-ui';
import { CartItemPriceViewComponent } from '../../../../../common/cart-item-price/views/cart-item-price-view/cart-item-price-view.component';

@Component({
  selector: 'ideal-standard-cart-item-summary-view',
  imports: [CartItemPriceViewComponent],
  standalone: true,
  templateUrl: './standard-cart-item-summary-view.component.html',
  styleUrl: './standard-cart-item-summary-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardCartItemSummaryViewComponent extends ItemComponentBase {
  public readonly quantity = input.required<number>();
}
